/**
 * Generated from PlanterCustomizeIntroLayout.fla
 */
export function PlanterCustomizeIntroLayout(this: IPlanterCustomizeIntroLayout) {
	const bg = this.bg;
	PlanterCustomizeIntroLayout_bg.call(this.bg);
	bg.x = 163.7;
	bg.y = -85.75;
	bg.width = 2479.34;
	bg.height = 1144.31;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	PlanterCustomizeIntroLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const grover = this.grover;
	PlanterCustomizeIntroLayout_grover.call(this.grover);
	grover.x = 726.75;
	grover.y = 681.6;
	grover.width = 295.40;
	grover.height = 596.40;
	if (grover.onLayout) grover.onLayout();
	const abby = this.abby;
	PlanterCustomizeIntroLayout_abby.call(this.abby);
	abby.x = 375.85;
	abby.y = 653.8;
	abby.width = 308.97;
	abby.height = 382.05;
	if (abby.onLayout) abby.onLayout();
	const skipButton = this.skipButton;
	PlanterCustomizeIntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 946.25;
	skipButton.y = 687.75;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	return this;
}
function PlanterCustomizeIntroLayout_bg(this: IPlanterCustomizeIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlanterParty-Background.png", 0.198, 0.254);
	return this;
}
function PlanterCustomizeIntroLayout_homeButton(this: IPlanterCustomizeIntroLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeIntroLayout_grover(this: IPlanterCustomizeIntroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-wave.png", 0.607, 0.995);
	return this;
}
function PlanterCustomizeIntroLayout_abby(this: IPlanterCustomizeIntroLayout_abby) {
	if (this.setLayoutTexture) this.setLayoutTexture("abby.png", 0.562, 0.916);
	return this;
}
function PlanterCustomizeIntroLayout_skipButton(this: IPlanterCustomizeIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
interface IPlanterCustomizeIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPlanterCustomizeIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPlanterCustomizeIntroLayoutSprite extends IPlanterCustomizeIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPlanterCustomizeIntroLayoutText extends IPlanterCustomizeIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPlanterCustomizeIntroLayoutPolygon extends Array<number> {
}
interface IPlanterCustomizeIntroLayout {
	readonly bg: IPlanterCustomizeIntroLayout_bg;
	readonly homeButton: IPlanterCustomizeIntroLayout_homeButton;
	readonly grover: IPlanterCustomizeIntroLayout_grover;
	readonly abby: IPlanterCustomizeIntroLayout_abby;
	readonly skipButton: IPlanterCustomizeIntroLayout_skipButton;
}
interface IPlanterCustomizeIntroLayout_bg extends IPlanterCustomizeIntroLayoutSprite {
}
interface IPlanterCustomizeIntroLayout_homeButton extends IPlanterCustomizeIntroLayoutSprite {
}
interface IPlanterCustomizeIntroLayout_grover extends IPlanterCustomizeIntroLayoutSprite {
}
interface IPlanterCustomizeIntroLayout_abby extends IPlanterCustomizeIntroLayoutSprite {
}
interface IPlanterCustomizeIntroLayout_skipButton extends IPlanterCustomizeIntroLayoutSprite {
}
